var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            "confirm-loading": _vm.confirmLoading,
            width: 620
          },
          on: { cancel: _vm.handleCancel }
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                { key: "cancel", on: { click: _vm.handleCancel } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              !_vm.disabled
                ? _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleOk }
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-col": { span: 7 },
                "wrapper-col": { span: 17 }
              }
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "框架合同编号:", prop: "contractNo" } },
                [
                  _c("a-input", {
                    staticStyle: { width: "220px" },
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.form.contractNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "contractNo", $$v)
                      },
                      expression: "form.contractNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                { attrs: { label: "卖方名称:", prop: "sellrOrgCode" } },
                [
                  _vm.type === "1"
                    ? _c(
                        "a-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            placeholder: "请选择",
                            disabled: _vm.disabled
                          },
                          model: {
                            value: _vm.form.sellrOrgCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "sellrOrgCode", $$v)
                            },
                            expression: "form.sellrOrgCode"
                          }
                        },
                        _vm._l(_vm.sellOptions, function(item) {
                          return _c(
                            "a-select-option",
                            {
                              key: item.orgCode,
                              attrs: { value: item.orgCode }
                            },
                            [_vm._v(_vm._s(item.userName) + "\n          ")]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "2"
                    ? _c(
                        "a-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            "show-search": "",
                            placeholder: "请输入",
                            "default-active-first-option": false,
                            "show-arrow": false,
                            "filter-option": false,
                            "not-found-content": null,
                            disabled: _vm.disabled
                          },
                          on: { search: _vm.selectSellerName },
                          model: {
                            value: _vm.form.sellrOrgCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "sellrOrgCode", $$v)
                            },
                            expression: "form.sellrOrgCode"
                          }
                        },
                        _vm._l(_vm.sellList, function(item) {
                          return _c(
                            "a-select-option",
                            {
                              key: item.orgCode,
                              attrs: { value: item.orgCode }
                            },
                            [_vm._v(_vm._s(item.userName) + "\n          ")]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-radio-group",
                    {
                      staticStyle: { width: "150px", "margin-left": "20px" },
                      attrs: { disabled: _vm.disabled },
                      on: { change: _vm.typeChange },
                      model: {
                        value: _vm.type,
                        callback: function($$v) {
                          _vm.type = $$v
                        },
                        expression: "type"
                      }
                    },
                    [
                      _c("a-radio", { attrs: { value: "1" } }, [
                        _vm._v("圈子")
                      ]),
                      _vm._v(" "),
                      _c("a-radio", { attrs: { value: "2" } }, [_vm._v("键入")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                { attrs: { label: "附件上传:", prop: "fileId" } },
                [
                  _c("fileUpload", {
                    ref: "fileUpload",
                    attrs: {
                      accept:
                        ".png, .PNG, .jpg, .JPG, .jpeg, .JPEG, .pdf, .PDF",
                      showList: [_vm.file],
                      paramObj: _vm.uploadParam,
                      disabled: _vm.disabled,
                      name: "file"
                    },
                    on: { uploadOk: _vm.uploadOk, remove: _vm.removeOk }
                  }),
                  _vm._v(" "),
                  !_vm.disabled
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("请上传png、jpg、jpeg、pdf格式的文件")
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e09954a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e09954a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/contract/AddPage.vue
// module id = dFwe
// module chunks = 1